import { createSlice } from "@reduxjs/toolkit";
import { checkAvailability } from "./carAvailabilityThunk";

const carAvailability = createSlice({
  name: "carAvailability",
  initialState: {
    date: "",
    session: "",
    people: 0,
    pickupPoint: "", // Add this
    status: "idle", // To track the loading state
    error: null,
  },
  reducers: {
    setDate: (state, action) => {
      state.date = action.payload;
    },
    setSession: (state, action) => {
      state.session = action.payload;
    },
    setPeople: (state, action) => {
      state.people = action.payload;
    },
    setPickupPoint: (state, action) => {
      state.pickupPoint = action.payload; // Add this
    },
    resetState: (state) => {
      return {
        date: "",
        session: "",
        people: "",
        status: "idle",
        error: null,
      };
    },
  },

  extraReducers: (builder) => {
    builder
      /*.addCase(bookTour.fulfilled, (state, action) => {
        //booking suceeded, clear state
        state.date = "";
        state.session = "";
        state.people = 0;
      })*/

      .addCase(checkAvailability.rejected, (state, action) => {
        //booking failed, show an error
        state.error = action.error.message;
      });
  },
});

export const {
  setDate,
  setSession,
  setPeople,
  setPickupPoint,
  resetState: resetCarAvailabilityState,
} = carAvailability.actions;

export default carAvailability.reducer;
